export const THEME_TYPES  = [
    {value: 'basic', label: 'Basic'}
]
